import { DanceManagerFeatureInterface, DanceManagerFeatureNameEnum } from '../../..';

export class DanceManagerFeatureDto implements DanceManagerFeatureInterface{
  id: string;
  description: string;
  name: DanceManagerFeatureNameEnum;
}
